const BRAND_METADATA_SCENARIO = "Brand Metadata";

const BRAND_METADATA_SUB_FEATURE_ORDER = [
  "Product Name",
  "Product Type",
  "Custom",
  "Pricing",
  "Price Discount",
  "Page",
  "Page Discount",
  "Percentage Discount",
  "CTA Text",
  "Shipping Offer",
] as const;

/**
 * Derive the Sub-categories (sub-feature) option list for the currently selected
 * Scenario(s) in My-Brand mode, from the `scenario → sub-features` map returned by
 * `/overview/subfeature-options`.
 *
 * - An empty scenario selection represents BigQuery's "All" case, so include
 *   sub-features from every scenario.
 * - Otherwise it's the union of the selected scenarios' sub-features.
 * Result is deduped and alphabetically sorted, except that when Brand Metadata is
 * explicitly selected its known sub-features lead in `BRAND_METADATA_SUB_FEATURE_ORDER`
 * and everything else follows alphabetically. Known sub-features are matched
 * case-insensitively (data may return "Cta Text") but keep the API's label.
 */
export function subFeatureOptionsForScenarios(
  map: Record<string, string[]>,
  scenarios: string[],
): string[] {
  const pool = scenarios.length ? scenarios : Object.keys(map);
  const set = new Set<string>();
  for (const s of pool) (map[s] ?? []).forEach((v) => set.add(v));
  const sorted = [...set].sort();
  if (!scenarios.includes(BRAND_METADATA_SCENARIO)) return sorted;

  const pinned = BRAND_METADATA_SUB_FEATURE_ORDER.flatMap((label) =>
    sorted.filter((v) => v.toLowerCase() === label.toLowerCase()),
  );
  return [...pinned, ...sorted.filter((v) => !pinned.includes(v))];
}
